import { Component } from '@angular/core';
import { WatchTowerService } from 'src/app/services/watch-tower.service';

@Component({
  selector: 'app-pop-out-panel',
  templateUrl: './pop-out-panel.component.html',
  styleUrls: ['./pop-out-panel.component.less']
})
export class PopOutPanelComponent {
  constructor(public twr: WatchTowerService){}

  log(){
    console.log(this.twr.events);
  }
}
